var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTotalInvoicesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9779",
    "data-name": "Group 9779",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38.365,
    height: 54.212,
    viewBox: "0 0 38.365 54.212",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3952",
    "data-name": "Rectangle 3952",
    width: 38.365,
    height: 54.212,
    fill: "#2a4c7d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9739",
    "data-name": "Group 9739",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12133",
    "data-name": "Path 12133",
    d: "M36.052,53.814a1.354,1.354,0,0,0,2.313-.958V5.317A5.319,5.319,0,0,0,33.048,0H5.317A5.319,5.319,0,0,0,0,5.317V52.856a1.354,1.354,0,0,0,2.313.958L7.3,48.831l4.983,4.983a1.353,1.353,0,0,0,1.915,0h0l4.984-4.983,4.984,4.983a1.353,1.353,0,0,0,1.915,0h0l4.983-4.983ZM9.278,40.345H23.144a1.355,1.355,0,1,0,0-2.711H9.278a1.355,1.355,0,0,0,0,2.711m0-5.941H29.087a1.355,1.355,0,0,0,0-2.711H9.278a1.355,1.355,0,0,0,0,2.711m6.278-14.212a5.649,5.649,0,0,0,.525-1.7H14.538a1.392,1.392,0,0,1,0-2.784h1.738c0-.03,0-.061,0-.089.024-2.524.06-5.98,3.838-6.413a4.137,4.137,0,0,1,4.352,2.922A1.393,1.393,0,0,1,21.821,13a1.4,1.4,0,0,0-1.39-1.027c-1.137.131-1.341.679-1.371,3.674V15.7h2.647a1.392,1.392,0,0,1,0,2.784H18.917a8.474,8.474,0,0,1-.881,2.962,3.126,3.126,0,0,1-.549.782H23.9a1.392,1.392,0,1,1,0,2.784H14.538a1.553,1.553,0,0,1-1.508-.968c-.415-1.074.392-1.813,1.418-2.747a9.421,9.421,0,0,0,1.107-1.11",
    transform: "translate(0 0)",
    fill: "#2a4c7d",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalInvoicesIcon);
export default __webpack_public_path__ + "static/media/TotalInvoicesIcon.2d7ca2baf2448c5ab159c0bb8f58b8f2.svg";
export { ForwardRef as ReactComponent };